export default {
  'error.message.403.description':
    'Xin lỗi, bạn không có quyền truy cập trang này.',
  'error.message.404.description':
    'Xin lỗi, trang bạn đã truy cập không tồn tại.',
  'error.message.unknown': 'Đã có lỗi xảy ra!',
};
